import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, Grid as ChakraGrid } from '@chakra-ui/react';
export const IzimiTableLayout = ({ children }) => children;
const Grid = ({ children, ...chakraProps }) => (_jsx(ChakraGrid, { height: '100%', display: { base: 'revert', lg: 'grid' }, templateColumns: '1fr auto', flex: 1, as: 'main', boxShadow: '0px 0px 24px rgb(61 56 54 / 8%)', zIndex: 1, ...chakraProps, children: children }));
const Table = ({ children }) => (_jsx(Flex, { as: 'article', direction: 'column', borderLeftWidth: { base: 0, lg: 1 }, borderLeftColor: 'neutral100', children: children }));
IzimiTableLayout.Grid = Grid;
IzimiTableLayout.Table = Table;
